package com.iregained.site.components.sections.about.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.AlignItems.Companion.Center
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val AboutLeadershipContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White)
}

val AboutLeadershipCategoryHeaderStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(1.75.cssRem).fontWeight(FontWeight.SemiBold)
        .textAlign(TextAlign.Center).margin(top = 48.px, bottom = 32.px)
}

val AboutLeadershipGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).gap(32.px)
}

val LeadershipCardStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().height(100.percent).display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
            .padding(32.px) // Increased padding for breathing room
            .borderRadius(24.px) // Softer, more modern corners
            .backgroundColor(Colors.White).border(1.px, LineStyle.Solid, rgba(0, 0, 0, 0.05)) // Extremely subtle border
            .boxShadow(5.px, 30.px, 60.px, 0.px, rgba(0, 0, 0, 0.15))
            .transition(Transition.of("transform", 250.ms), Transition.of("box-shadow", 250.ms))
    }
    hover {
        Modifier.transform { translateY((-12).px) }
            .boxShadow(10.px, 45.px, 90.px, 0.px, rgba(0, 0, 0, 0.30)) // Deeper shadow on hover
    }
}

val LeadershipImageContainerStyle = CssStyle.base {
    Modifier.position(Position.Relative).size(140.px) // Slightly scaled down to fit better in the grid
}

val LeadershipImageStyle = CssStyle {
    base {
        Modifier.size(140.px).borderRadius(50.percent).objectFit(ObjectFit.Cover)
            .boxShadow(0.px, 8.px, 20.px, 0.px, rgba(0, 0, 0, 0.1)).transition(Transition.of("transform", 300.ms))
    }
    hover {
        Modifier.transform { scale(1.05) }
    }
}

// Replaced the distracting infinite pulse with a clean, static badge that pops on hover
val LeadershipLinkedinIconStyle = CssStyle {
    base {
        Modifier.position(Position.Absolute).bottom(4.px) // Moved to bottom right for a more grounded feel
            .right(4.px) // Added white background so the icon pops against the photo
            .borderRadius(50.percent).display(DisplayStyle.Flex).justifyContent(JustifyContent.Center)
            .alignItems(Center).boxShadow(0.px, 4.px, 10.px, 0.px, rgba(0, 0, 0, 0.15))
            .transition(Transition.of("transform", 200.ms)).zIndex(1)
    }
    hover {
        Modifier.transform { scale(1.15) }
    }
}

val LeadershipNameStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
        .margin(bottom = 4.px).textAlign(TextAlign.Start) // Left aligned for readability
}

val LeadershipTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().brand.primary).fontSize(0.95.cssRem).fontWeight(FontWeight.SemiBold)
        .textAlign(TextAlign.Start) // Left aligned
        .margin(bottom = 6.px)
}

val LeadershipBioSnippetStyle = CssStyle.base {
    Modifier.color(Colors.DimGray) // Muted color for paragraph text to establish hierarchy
        .fontSize(0.95.cssRem).lineHeight(1.6).textAlign(TextAlign.Start) // Left aligned for optimal readability
}